import mutations from './priceList.mutations'
import actions from './priceList.actions'
import getters from './priceList.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
